import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { visuallyHidden } from "@mui/utils";
import { GrView } from "react-icons/gr";
import {  useState } from "react";
import { FiEdit } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { HEAD_CELLS_CUSTOMERS } from "../../../mockData";
import { updateCustomerID } from "../../../store/actions/CustomerActions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DeleteCustomerById } from "../../../services/helpers/customers";
import { Pagination } from "@mui/material";
import Cookies from "js-cookie";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc" ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, cId } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className="bg-gray-200">
      <TableRow>
        {HEAD_CELLS_CUSTOMERS.map((headCell, i) =>
          cId ? (
            headCell.id == "name" && (
              <TableCell key={headCell.id} align={headCell.left ? "left" : "right"} padding={headCell.disablePadding ? "none" : "normal"} className="!pl-4">
                {headCell.icon ? (
                  <TableSortLabel active={orderBy === headCell.id} direction={orderBy === headCell.id ? order : "asc"} onClick={createSortHandler(headCell.id)}>
                    {headCell.label}
                    {orderBy === headCell.id ? (
                      <Box component="span" sx={visuallyHidden}>
                        {order === "desc" ? "sorted descending" : "sorted ascending"}
                      </Box>
                    ) : null}
                  </TableSortLabel>
                ) : (
                  <p>{headCell.label}</p>
                )}
              </TableCell>
            )
          ) : (
            <TableCell  key={headCell.id} align={headCell.left ? "left" : "right"} padding={headCell.disablePadding ? "none" : "normal"} className="!pl-4 !font-semibold">
              {headCell.icon ? (
                <TableSortLabel active={orderBy === headCell.id} direction={orderBy === headCell.id ? order : "asc"} onClick={createSortHandler(headCell.id)}>
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === "desc" ? "sorted descending" : "sorted ascending"}
                    </Box>
                  ) : null}
                </TableSortLabel>
              ) : (
                <p>{headCell.label}</p>
              )}
            </TableCell>
          )
        )}
      </TableRow>
    </TableHead>
  );
}

const MuiTableCustomer = ({ cId, totalPageNumber, opPageChange, pageNum, CustomerLists, getCustomerList }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = CustomerLists.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const customerHandle = (id) => {
    dispatch(updateCustomerID({ id }));
  };
  const handleClick = (event, id) => {
    setSelected(id);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const customerDeleteHandle = (id) => {
    const choice = window.confirm("Are you sure you want to delete customer?");
    if (choice) {
      const queryParams = {
        customerId: id,
        userId: Cookies.get('userId')
      };
      const paramsData = { queryParams, headers: {},
      isAuthorized: true, };
      DeleteCustomerById(paramsData, (res) => {
        setTimeout(() => {
          navigate("/customers");
          getCustomerList();
        }, 200);
      });
    }
  };
  const customerEditHandle = (id) => {
    navigate("/customer/" + id);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {CustomerLists?.length > 0 ? (
        <Paper sx={{ width: "100%", mb: 2 }} className={`${"min-h-screen !mb-0 !rounded-none"}`}>
          <TableContainer>
            <Table aria-labelledby="tableTitle" size={"medium"} className={`${!cId && "min-w-[750px]"}`}>
              {!cId && (
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={CustomerLists.length}
                  cId={cId}
                />
              )}
              <TableBody>
                {stableSort(CustomerLists, getComparator(order, orderBy)).map((row, index) => {
                  // const isItemSelected = isSelected(row.firstName);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row.customerUniqueId)}
                      role="checkbox"
                      // aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.name}
                      selected={row.customerUniqueId == selected}
                    >
                      <TableCell className="!pl-4 cursor-pointer" component="th" id={labelId} scope="row" onClick={() => customerHandle(row.customerUniqueId)}>
                        {row.salutation} {row.firstName} {row.lastName}
                      </TableCell>
                      {!cId && <TableCell align="left">{row.companyName}</TableCell>}
                      {!cId && <TableCell align="left">{row.email}</TableCell>}
                      {!cId && <TableCell align="left">{row.work_phone}</TableCell>}

                      {!cId && (
                        <TableCell align="right" className="!p-2">
                          <div className="flex items-center justify-end">
                          <GrView className="mr-4 text-xl text-Apple cursor-pointer" onClick={() => customerHandle(row.customerUniqueId)} />
                            <FiEdit className="mr-2 text-xl text-Apple cursor-pointer" onClick={() => customerEditHandle(row.customerUniqueId)} />
                            <MdDelete className="text-xl text-red-600 cursor-pointer" onClick={() => customerDeleteHandle(row.customerUniqueId)} />
                          </div>
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          {totalPageNumber > 0 && (
            <div className="flex items-center justify-center py-5">
              <Pagination className="flex" count={totalPageNumber} page={pageNum} onChange={(e, page_number) => opPageChange(e, page_number)} color="primary" />
            </div>
          )}
        </Paper>
      ) : (
        <Paper sx={{ width: "100%", mb: 2 }} className={`${"min-h-screen !mb-0 !rounded-none"}`}>
          <h1 className="text-center py-12 pt-[12rem] text-lg font-bold">No data Found</h1>
        </Paper>
      )}
    </Box>
  );
};

export default MuiTableCustomer;
